import styled from '@emotion/styled'
import tokens from '@lacedltd/design-tokens'

export const ConfirmationError = styled.p({
  color: tokens.color.airPresto[800],
  position: 'relative',
  margin: `${tokens.spacing[2]} 0 0`
})

export const FormContainer = styled.div<{ marginY: boolean }>(
  ({ marginY }) => ({
    width: '100%',
    marginBottom: tokens.spacing[8],
    marginTop: marginY ? tokens.spacing[8] : undefined
  })
)

export const InputContainerLabel = styled.label<{ active: boolean }>(
  {
    marginBottom: tokens.spacing[3],
    transition: 'all 0.2s ease-in-out',
    '&:last-child': {
      marginBottom: tokens.spacing[6]
    }
  },
  ({ active }) =>
    active
      ? {
          color: tokens.color.airJordan.p,
          transition: 'all 0.2s ease-in-out'
        }
      : {}
)

export const InputContainerLabelText = styled.span({
  display: 'inline-block',
  marginBottom: tokens.spacing[2]
})

export const InputContainer = styled.div<{ error: boolean }>(({ error }) => ({
  position: 'relative',
  input: {
    boxSizing: 'border-box',
    display: 'flex',
    alignItems: 'center',
    padding: `${tokens.spacing[3]} ${tokens.spacing[5]}`,
    height: '3.5rem', //56px
    textAlign: 'left',
    borderColor: error ? tokens.color.airPresto[800] : undefined
  }
}))

export const VisibilityToggleButton = styled.button({
  color: tokens.color.airJordan[600],
  textTransform: tokens.textCase.upperCase,
  position: 'absolute',
  top: '50%',
  right: tokens.spacing[5],
  transform: 'translateY(-50%)',
  '&:hover': {
    cursor: 'pointer'
  }
})
